// extracted by mini-css-extract-plugin
export default {"copy":"style_copy__EH1nK","copy__icon":"style_copy__icon__4aJdi"};